import * as React from "react";

import {
  FeatureController,
  FeaturesProvider,
  OneTimePasswordFeatures,
  useOneTimePasswordFeatureController,
} from "../../../Common";

import { useReactWishlistGuestInitialState } from "../react-wishlist-guest-initial-state-provider";

export const ReactWishlistGuestFeatures = OneTimePasswordFeatures;

export const ReactWishlistGuestFeaturesProvider: React.FunctionComponent = (props) => {
  const { initialState } = useReactWishlistGuestInitialState();

  const oneTimePasswordFeatureController = useOneTimePasswordFeatureController({
    initialState,
  });

  const features: FeatureController[] = React.useMemo(
    () => [oneTimePasswordFeatureController],
    [oneTimePasswordFeatureController]
  );

  return (
    <FeaturesProvider features={features}>
      {props.children || []}
    </FeaturesProvider>
  );
};
